import officeInformation from './officeInformation'

export default { officeInformation }
